var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex w-100 h-100"},[_c('Navbar'),_c('div',{staticClass:"flex-grow-1",attrs:{"id":"content"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }